import ReturnsRmaRowMobile from './ReturnsRmaRowMobile';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsRmaRowMobile);
